import React from 'react';
import { useParams } from 'react-router-dom';
import TeacherAdminDetailPage from '../domains/admin/components/TeacherAdminDetailPage';

const AdminTeacherDetailPage: React.FC = () => {
  const { teacherId } = useParams<{ teacherId: string }>();
  if (!teacherId) return <div style={{ padding: 16 }}>Missing teacherId.</div>;
  return <TeacherAdminDetailPage teacherId={teacherId} />;
};

export default AdminTeacherDetailPage;
